export const Config = {
   //API_BASE_PATH: "https://humimicai.com/wollemiAPI/",
   //API_BASE_PATH_HWS: "https://humimicai.com/wollemiAPIHWS/",
   //API_BASE_PATH: "http://ec2-13-233-48-227.ap-south-1.compute.amazonaws.com/wollemiAPI/",
   //API_BASE_PATH_HWS: "http://ec2-13-233-48-227.ap-south-1.compute.amazonaws.com/wollemiAPIHWS/",
  API_BASE_PATH: "/wollemiAPI/",
  API_BASE_PATH_HWS: "/wollemiAPIHWS/",
  APPOINTMENT_FORM: "user/appointment",
  FAQ_FORM: "user/faq",
  RAISE_ISSUE_LOGIN: "user/raiseIssueApi",
  RAISE_AN_ISSUE: "manavAPI/raiseIssueApi/raiseAnIssue",

  //LOGIN-SCREEN
  CHECK_IP_LOGIN: "user/ipLogin",
  LOGIN: "user/login",
  RESET_PASSWORD_SUBMIT: "manavAPI/resetPassword/resetPasswordSubmit",
  FORGET_PASSWORD: "user/forgetPassword/forgetPasswordEmail",
  FORGET_PASSWORD_POLICY: "user/forgetPassword/forgetPasswordReset",
  FORGET_PASSWORD_SUBMIT: "user/forgetPassword/forgetPasswordResetSubmit",
  GET_IP_ADDRESS_URL: "user/userIp",

  //NOTIFICATION
  NOTIFICATION: "manavAPI/notification/getNotification",
  UPDATE_NOTIFICATION_STATUS: "manavAPI/notification/updateNotification",
  SINGLE_NOTIFICATION_INFO: "manavAPI/notification/getSingleNotification",
  BLOCK_ACTIVATION: "manavAPI/project/updateBlockSize",

  //PROJECT-SCREEN
  PROJECTS_LIST: "manavAPI/project/projectsList",
  PROJECTS_DELETE: "manavAPI/project/projectsDelete",
  REPLICATE_PROJECT: "manavAPI/project/replicate",

  //CONTRACT-MIS
  GET_CONTRACTS_LIST: "manavAPI/myCollection/contractsList",
  CONTRACT_MIS: "manavAPI/myCollection/projectsSummary",
  CONTRACT_MIS_FILTER: "manavAPI/myCollection/filteredProjectsSummary",

  //MANAGEMENT-SUMMARY
  GET_MANAGEMENT_SUMMARY: "manavAPI/myCollection/getManagementSummary",
  TOTAL_EXPENSE_DATA: "manavAPI/myCollection/totalExpenseData",
  GET_RATIO_DATA: "manavAPI/myCollection/getParticularRatioData",
  REMOVE_USER_FROM_SUMMARY: "manavAPI/myCollection/removeContractUser",
  ADD_USER_FROM_SUMMARY: "manavAPI/myCollection/addContractUser",
  TRIGGER_INVOICE: "manavAPI/myCollection/triggerInvoice",
  GET_USER_EDIT_DETAIL: "manavAPI/myCollection/getUserDetail",
  UPDATE_USER: "manavAPI/myCollection/updateContractUser",

  //CREATE-PROJECT
  CREATE_PROJECT_LISTS: "manavAPI/project/createProjectLists",
  CREATE_PROJECT_SUBMIT: "manavAPI/project/createProjectSubmit",
  UPDATE_PROJECT: "manavAPI/project/updateProject",
  READ_PROJECT_LISTS: "manavAPI/project/createProjectReadable",

  //Profile
  RESET_CREDENTIALS: "manavAPI/user/resetCredentials",
  USER_PROFILE_INFO: "manavAPI/userProfile/getUserProfile",

  //HWS
  GET_HWS_DETAILS: "manavAPI/hws/get-hws-details",
  SAVE_HWS_DETAILS: "manavAPI/hws/submit-hws-details",
  HWS_PAGELOAD: "manavAPI/hws/onPageLoad",
  HWS1_SPELL_CHECK: "manavAPI/hws/spellChecker",
  HWS_LIST: "manavAPI/hws/getHwsList",
  HWS_ON_GO: "manavAPI/hwsOutcome/onGo",
  HWS_OUTCOME: "manavAPI/hwsOutcome/getHwsOutcome",
  HWS_UPDATE_ONGO: "manavAPI/hwsOutcome/updateOntheGo",
  HWS_GRAPH_PAGELOAD: "manavAPI/hwsOutcome/hwsGraphPageLoad",
  HWS_GRAPH: "manavAPI/hwsOutcome/hwsGraph",
  HWS_CREATE_EXCEL: "manavAPI/export/createExcelHws",
  HWS_CREATE_EXCEL_DETAIL: "manavAPI/exportHws/createExcelHwsDetail",
  CREATE_PDF_DOCUMENT: "manavAPI/export/createPdfDocument",
  HWS_EXPORT: "manavAPI/hwsOutcome/createDocumentAnalysis",
  SELECT_OPPORTUNITY_HWS: "manavAPI/hwsOutcome/selectOpportunity",
  DESELECT_OPPORTUNITY_HWS: "manavAPI/hwsOutcome/deselectOpportunity",
  SAVE_OPPORTUNITY_HWS: "manavAPI/hwsOutcome/saveOpportunity",
  UNSAVE_OPPORTUNITIES_HWS: "manavAPI/hwsOutcome/unsaveOpportunity",
  SAVED_OPPORTUNITIES_HWS: "manavAPI/hwsOutcome/savedOpportunities",
  DEEP_HWS_SEARCH: "manavAPI/hwsOutcome/deepSearch",
  HWS_VIEW_DETAIL: "manavAPI/hwsOutcome/getViewDetail",
  DOCUMENT_CREATE_DB: `manavAPI/export/createDocumentFromUI`,

  //ChatBot
  CHAT_BOT: "manavAPI/chatBot/getAnswers",
  CHAT_BOT_RESET: "manavAPI/chatBot/resetChat",
  CHAT_BOT_PREVIOUS: "manavAPI/chatBot/previousChat",
  CHAT_BOT_PREVIOUS1: "manavAPI/chatBot/previousChat1",
  CHAT_BOT_FILTER: "manavAPI/hwsOutcome/getHwsOutcomeChat",

  //Biological
  BIO_PROJECTS_LIST: "manavAPI/biological/projectsList",

  //Insights
  GET_VALUE_MATRIX_DATA: "manavAPI/insights/getValueMatrixData",
};

export const ConfigBIO = {
  // API_BASE_PATH: "http://localhost:5000/",
  // API_BASE_PATH_BIOLOGICAL: "http://localhost:5000/",
  // API_BASE_PATH: "http://ec2-13-203-232-176.ap-south-1.compute.amazonaws.com//wollemiAPIBIO/",
  // API_BASE_PATH_BIOLOGICAL: "http://ec2-13-203-232-176.ap-south-1.compute.amazonaws.com//wollemiAPIBIO/",
  API_BASE_PATH: "/wollemiAPIBIO/",
  API_BASE_PATH_BIOLOGICAL: "/wollemiAPIBIO/",

  GET_BIOLOGICAL_DETAILS: "stratAPI/biologicalInput/get-hws-details",
  SAVE_BIOLOGICAL_DETAILS: "stratAPI/biologicalInput/submit-hws-details",
  BIOLOGICAL_PAGELOAD: "stratAPI/biologicalInput/onPageLoad",
  BIOLOGICAL_SPELL_CHECK: "stratAPI/biologicalInput/spellChecker",
  BIOLOGICAL_LIST: "stratAPI/biologicalInput/getHwsList",
  BIOLOGICAL_ON_GO: "stratAPI/biologicalOutcome/onGo",
  BIOLOGICAL_OUTCOME: "stratAPI/biologicalOutcome/getHwsOutcome",
  BIOLOGICAL_UPDATE_ONGO: "stratAPI/biologicalOutcome/updateOntheGo",
  BIOLOGICAL_GRAPH_PAGELOAD: "stratAPI/biologicalOutcome/hwsGraphPageLoad",
  BIOLOGICAL_GRAPH: "stratAPI/biologicalOutcome/hwsGraph",
  BIOLOGICAL_CREATE_EXCEL: "stratAPI/export/createExcelHws",
  BIOLOGICAL_CREATE_EXCEL_DETAIL: "stratAPI/exportBiological/createExcelHwsDetail",
  CREATE_PDF_DOCUMENT: "stratAPI/export/createPdfDocument",
  BIOLOGICAL_EXPORT: "stratAPI/biologicalOutcome/createDocumentAnalysis",
  SELECT_OPPORTUNITY_BIOLOGICAL: "stratAPI/biologicalOutcome/selectOpportunity",
  DESELECT_OPPORTUNITY_BIOLOGICAL: "stratAPI/biologicalOutcome/deselectOpportunity",
  SAVE_OPPORTUNITY_BIOLOGICAL: "stratAPI/biologicalOutcome/saveOpportunity",
  UNSAVE_OPPORTUNITIES_BIOLOGICAL: "stratAPI/biologicalOutcome/unsaveOpportunity",
  SAVED_OPPORTUNITIES_BIOLOGICAL: "stratAPI/biologicalOutcome/savedOpportunities",
  DEEP_BIOLOGICAL_SEARCH: "stratAPI/biologicalOutcome/deepSearch",
  BIOLOGICAL_VIEW_DETAIL: "stratAPI/biologicalOutcome/getViewDetail",
  DOCUMENT_CREATE_DB: `stratAPI/export/createDocumentFromUI`,
  CHAT_BOT_FILTER: "stratAPI/biologicalOutcome/getHwsOutcomeChat",
  INDICATION_ASSESSMENT_MAIN_SCREEN: "stratAPI/biologicalOutcome/mainScreenData",
}

export const ConfigCON = {
  //API_BASE_PATH: "https://humimicai.com/wollemiAPICON/",
  //API_BASE_PATH_CONSUMER: "https://humimicai.com/wollemiAPICON/",
  // API_BASE_PATH: "http://ec2-13-203-232-176.ap-south-1.compute.amazonaws.com//wollemiAPICON/",
  // API_BASE_PATH_CONSUMER: "http://ec2-13-203-232-176.ap-south-1.compute.amazonaws.com//wollemiAPICON/",
  API_BASE_PATH: "/wollemiAPICON/",
  API_BASE_PATH_CONSUMER: "/wollemiAPICON/",


  GET_CONSUMER_DETAILS: "manavAPI/hws/get-hws-details",
  SAVE_CONSUMER_DETAILS: "manavAPI/hws/submit-hws-details",
  CONSUMER_PAGELOAD: "manavAPI/hws/onPageLoad",
  CONSUMER_SPELL_CHECK: "manavAPI/hws/spellChecker",
  CONSUMER_LIST: "manavAPI/hws/getHwsList",
  CONSUMER_ON_GO: "manavAPI/hwsOutcome/onGo",
  CONSUMER_OUTCOME: "manavAPI/hwsOutcome/getHwsOutcome",
  CONSUMER_UPDATE_ONGO: "manavAPI/hwsOutcome/updateOntheGo",
  CONSUMER_GRAPH_PAGELOAD: "manavAPI/hwsOutcome/hwsGraphPageLoad",
  CONSUMER_GRAPH: "manavAPI/hwsOutcome/hwsGraph",
  CONSUMER_CREATE_EXCEL: "manavAPI/export/createExcelHws",
  CONSUMER_CREATE_EXCEL_DETAIL: "manavAPI/exportHws/createExcelHwsDetail",
  CREATE_PDF_DOCUMENT: "manavAPI/export/createPdfDocument",
  CONSUMER_EXPORT: "manavAPI/hwsOutcome/createDocumentAnalysis",
  SELECT_OPPORTUNITY_CONSUMER: "manavAPI/hwsOutcome/selectOpportunity",
  DESELECT_OPPORTUNITY_CONSUMER: "manavAPI/hwsOutcome/deselectOpportunity",
  SAVE_OPPORTUNITY_CONSUMER: "manavAPI/hwsOutcome/saveOpportunity",
  UNSAVE_OPPORTUNITIES_CONSUMER: "manavAPI/hwsOutcome/unsaveOpportunity",
  SAVED_OPPORTUNITIES_CONSUMER: "manavAPI/hwsOutcome/savedOpportunities",
  DEEP_CONSUMER_SEARCH: "manavAPI/hwsOutcome/deepSearch",
  CONSUMER_VIEW_DETAIL: "manavAPI/hwsOutcome/getViewDetail",
  DOCUMENT_CREATE_DB: `manavAPI/export/createDocumentFromUI`,
  CHAT_BOT_FILTER: "manavAPI/hwsOutcome/getHwsOutcomeChat",
  GET_VALUE_MATRIX_DATA: "manavAPI/hwsOutcome/getValueMatrixData",
}